export default {
  allVehicleTypes: [],
  vehicleType: {},
}
